import { API_V2 } from "@Models/GWDomain";
import { ApiResponse, postData } from "@Services/constServices";
import { typeDoc } from "@Utilities/typeDoc";

export const postCreateNewClient = async (form): Promise<ApiResponse> => {
  const sex = (s: string) => {
    if (s === "MASCULINO") return 1;
    if (s === "FEMENINO") return 2;
    if (s === "OTRO") return 3;
    return 0;
  };

  const categoryId =
    form.categoryClientId === "" ? null : Number(form.categoryClientId);

  // Si el cliente se negó a dar su teléfono, la ficha va sin número: se guarda
  // la negativa, no un placeholder que después se manda a WhatsApp y ensucia
  // la búsqueda de la caja.
  const phoneRefused = form.phoneRefused === true;
  const phone = phoneRefused ? "" : form.phoneNumber;

  const data = {
    firstName: form.name,
    lastName: form.lastName,
    email: form.email,
    phone,
    phoneRefused,
    // El formulario expone el código como codeCountryPhone; antes se leía
    // form.phoneCode (inexistente) y el país se perdía al crear el cliente.
    codeCountryPhone: phone ? form.codeCountryPhone : "",
    documentType: typeDoc(form.documentType),
    documentNumber: `${form.documentNumber}`,
    categoryClientId: categoryId,
    gender: sex(form.sex),
    birthdate: form.birthdate === "" ? null : form.birthdate,
    address: form.address,
  };

  const url = `${API_V2}/customers`;
  return postData(url, data);
};
